// Library
import React from 'react';
// Utils
import { useStyles } from './style';
/**
 * @deprecated
 */
var IconText = function (props) {
    var text = props.text, Icon = props.icon;
    var classes = useStyles(props);
    return (React.createElement("div", { className: classes.container },
        Icon && (React.createElement("div", { "data-testid": 'icontext-icon', className: classes.iconComponent },
            React.createElement(Icon, null))),
        text && (React.createElement("div", { "data-testid": 'icontext-text', className: classes.textComponent }, text))));
};
export default IconText;
//# sourceMappingURL=IconText.js.map